import { countryInfoRussia } from '../../../constants/constants';
import { getForeingAddress } from '../FiasOverrider.helpers';
import { convertAddressItemToFiasAddressItem } from './convertAddressItemToFiasAddressItem';
import { convertCountrySSToFiasCountry } from './convertCountrySSToFiasCountry';
import { convertFlatToFiasRoom } from './convertFlatToFiasRoom';
import { convertHouseToGarHouse } from './convertHouseToGarHouse';
export const convertSSAddressToFiasAddress = (address) => {
    const countryCode = address?.country?.code || countryInfoRussia.code;
    if (countryCode !== countryInfoRussia.code) {
        return {
            fiasId: '',
            address: {},
            addressErrors: {},
            addressString: address?.text || '',
            postalCode: address?.postalCode || '',
            foreignAddress: getForeingAddress({
                addressString: address?.text || undefined,
                postalCode: address?.postalCode || undefined,
                countryFullName: address?.country?.name,
            }),
            country: convertCountrySSToFiasCountry(address?.country),
        };
    }
    return {
        fiasId: address?.room?.fiasId || address?.flat?.fiasId || address?.house?.fiasId || '',
        postalCode: address?.postalCode || '',
        addressString: address?.text || '',
        addressErrors: {},
        country: convertCountrySSToFiasCountry(address?.country),
        address: {
            region: convertAddressItemToFiasAddressItem(address?.region),
            city: convertAddressItemToFiasAddressItem(address?.city),
            intracityarea: convertAddressItemToFiasAddressItem(address?.intracityArea),
            urbansettlement: convertAddressItemToFiasAddressItem(address?.urbanSettlement),
            settlement: convertAddressItemToFiasAddressItem(address?.settlement),
            planningstructure: convertAddressItemToFiasAddressItem(address?.planningStructure),
            district: convertAddressItemToFiasAddressItem(address?.district),
            street: convertAddressItemToFiasAddressItem(address?.street),
            stead: convertAddressItemToFiasAddressItem(address?.stead),
            garhouse: convertHouseToGarHouse(address?.house),
            room: convertFlatToFiasRoom(address?.flat, address.room),
            municipaldistrict: convertAddressItemToFiasAddressItem(address?.municipalDistrict),
        },
    };
};
